
export { trackError } from "/vercel/path0/libs/error-boundary/src/lib/utils.ts"